<template>
  <div class="col-12 col-md-12 col-lg-7 text-center">
    <div class="tit">
      <p>Os sócios da empresa possuem algum financiamento já contratado?</p>
    </div>
    <div class="text-center fixedOptions">
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithCorporateGroup">Sim</button>
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithoutCorporateGroup">Não</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    submitWithCorporateGroup() {
      this.$emit('on-submit', {Empresa: {SociosTemFinanciamento: true}})
    },
    submitWithoutCorporateGroup() {
      this.$emit('on-submit', {Empresa: {SociosTemFinanciamento: false}})
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/FinanciamentosSociosStep.vue